/**
 * The three layers anything floating belongs to, and the only place they are
 * decided.
 *
 * Until 2026-09-25 a dialog carried **no z-index at all**, which is invisible
 * right up until it is not: `position: relative` with `z-index: auto` creates
 * no stacking context, so a `z-10` badge inside a card two levels down sits in
 * the *root* context and paints straight through a backdrop that is only
 * `fixed`. The products list showed two crisp «No photo» pills floating over a
 * blurred page the first time a dialog was opened over it.
 *
 * So: a dialog is above the page, a popup is above the dialog — because a
 * select inside a dialog is the ordinary case and it must not open behind the
 * thing that owns it — and a toast is above everything, because it reports on
 * what just happened and may say the dialog failed.
 */
export const LAYER = {
  /** Dialogs and their backdrops. */
  dialog: 'z-40',
  /** Anything a control opens: select, menu, combobox, context menu. */
  popup: 'z-50',
  /** Toasts, which outrank both. */
  toast: 'z-[60]',
} as const;
